import Warning from "@mui/icons-material/Warning";
import { SxProps, Theme, Tooltip } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import React, { ReactNode } from "react";

interface WarningIconProps {
  tip: NonNullable<ReactNode>;
  className?: string;
  sx?: SxProps;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    warningIcon: {
      color: theme.palette.warning.light,
      fontSize: "24px",
    },
  })
);

const WarningIcon = ({ tip, sx, className }: WarningIconProps) => {
  const classes = useStyles();
  return (
    <Tooltip title={tip}>
      <Warning
        sx={sx}
        classes={{ root: classes.warningIcon }}
        className={className} />
    </Tooltip>
  );
};

export default WarningIcon;
